import { Component, OnInit } from '@angular/core';
import { InterCopmonentDataCarrierService } from '../../../../../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service';
import { FeeSummary } from '../../models/fee-summary';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { FeesService } from '../../services/fees.service';
import { FileDownloadService } from '../../../../../services/file-download-service/file-download.service';
import { AppSettings } from '../../../../../utils/app-settings';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { LocalStorageService } from '../../../../../services/local-storage-service/local-storage.service';

@Component({
  selector: 'app-fee-details',
  templateUrl: './fee-details.component.html',
  styleUrls: ['./fee-details.component.scss']
})
export class FeeDetailsComponent extends ComponentBase implements OnInit {

  constructor(private interCopmonentDataCarrierService: InterCopmonentDataCarrierService
    , private feesService: FeesService
    , private fileDownloadService: FileDownloadService
    , private routingService: RoutingService
    , private localStorageService: LocalStorageService) {
    super();
  }
  fee: FeeSummary;
  studentid: number;
  ngOnInit() {
    this.fee = this.interCopmonentDataCarrierService.retrieve("fee_item");
    this.interCopmonentDataCarrierService.delete("fee_item");
    if (!this.fee) {
      let route = new PrifactRoute();
      route.primary_command = ['pages', 'fees'];
      route.clear_history = true;
      this.routingService.navigate(route);
    }

    this.studentid = this.localStorageService.getItem(AppSettings.LocalStorageUserContextKey).student_id;
  }

  payNowClicked(fee: FeeSummary) {
    var newWindow = window.open('', '_blank');
    let subscription = this.feesService.getPaymentUrl(fee.fee_payment_group_name)
      .subscribe(res => {
        newWindow.location.href = res;
      });
    this.addSubscription(subscription);
  }

  downloadReceipt(fee: FeeSummary) {
    let fee_payment_group_name_installment_date =  fee.fee_payment_group_name ? fee.fee_payment_group_name : fee.installment_date.split('T')[0];
    let url = AppSettings.apiUrl + "fees/receipt/" + (fee_payment_group_name_installment_date) + "?StudentID=" + this.studentid;
    this.fileDownloadService.downloadAndOpen(url, "receipt.pdf", "application/pdf").subscribe();
  }

}
